import { Component } from '@angular/core';
@Component({
  selector: 'tlm-logo',
  templateUrl: './logo.component.html',
  imports: [],
})
export class LogoComponent {}
